import Image, { ImageProps } from 'next/image'
import styles from './style.module.css'
import React, { FunctionComponent, ReactNode, useState } from 'react'
import clsx from 'clsx'

type ImageShape = 'circle' | 'square'
interface ImageWithFallbackProps extends ImageProps {
  fallback: ReactNode
  shape?: ImageShape
}

export const ImageWithFallback: FunctionComponent<ImageWithFallbackProps> = ({ src, fallback, alt, shape = 'square', ...restProps }) => {
  const [isLoadingImageError, setIsLoadingImageError] = useState(false)

  const imageModifier = clsx(shape === 'circle' && styles.circleWrapper)

  const onImageLoadError = (): void => {
    setIsLoadingImageError(true)
  }

  return isLoadingImageError ? fallback : <Image className={imageModifier} src={src} alt={alt} onError={onImageLoadError} {...restProps} />
}
